import { Injectable } from '@angular/core';
import { Order } from '../interfaces/order';
import { ApiService } from './api.service';
import { ApiV1Service } from './api.v1.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(
    private api: ApiService,
    private apiV1: ApiV1Service
  ) { }

  public getPaymentMethods(): Array<string> {
    return [
      'ideal',
      'creditcard',
      // 'paypal'
    ];
  }

  public getPaymentMethodsToSubscription(): Array<string> {
    return [
     // 'ideal',
      'creditcard',
      // 'paypal'
    ];
  }

  public get(id: number): Promise<Order> {
    return this.api.get('/order/' + id).then( (res) => {
      if (res.result == 'success') {
        return res.data
      }
      return res;
    });
  }

  public query(params: any | null): Promise<any> {
    // Params
    if (!params) {
      params = {};
    }

    return this.api.get('/order', params);
  }

  public validateVat (params: {country_code: string | null, vat_number?: string | null} | null) {
    if (!params) {
      params = {
        country_code: null,
        vat_number: null
      }
    }

    return this.api.get('/payment/check_vat', params);
  }

  public save(order: Order): Promise<Order> {
    return this.api.postJSON('/order', order).then( (res) => {
      return res.data;
    });
  }

  public pay(order: Order, currency: string = 'EUR'): Promise<any> {
    if (environment.paymentsProvider === 'walleq') {
      return this.payViaWalleq(order, currency);
    }
    return this.api.post('/order/' + order.id + '/pay', {});
  }

  public paySubscription(order: Order): Promise<any> {
    // Suscripciones todavía van siempre por Mollie — walleq.subscriptions pendiente.
    return this.api.post('/order/' + order.id + '/pay-subscription', {});
  }

  private payViaWalleq(order: Order, currency: string): Promise<any> {
    return this.apiV1.postJSON('/payments/order/' + order.id + '/pay', { currency })
      .then((res: any) => {
        // Mantengo el shape { data: url } para no romper CheckoutService.
        // Hoy solo hay un provider habilitado (Stripe); si en el futuro hay varios,
        // el modal debería mostrar un selector y usar providers[].
        const providers = res?.providers || [];
        if (!providers.length) {
          throw new Error('walleq: no providers returned');
        }
        return { data: providers[0].url, payment_id: res.payment_id, providers };
      });
  }

  public applyCoupon(order: Order, couponCode: string, params:any=null): Promise<any> {
    return this.api.post('/order/' + order.id + '/coupon', {
      code: couponCode,
      in_total: params?params.in_total:null,
      in_tax: params?params.tax:null,
      
      discount_net: params?params.discount_net:null,
      discount_tax: params?params.discount_tax:null
    });
  }
}
